import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const HorsesRepository = RepositoryFactory.get('horse')

class HorseService {
  static async getHorses (params) {
    try {
      return await HorsesRepository.getHorses(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getHorse (horseId, params) {
    try {
      return await HorsesRepository.getHorse(CredentialsService.getCurrentTenantId(), horseId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateHorse (horseId, data) {
    try {
      return await HorsesRepository.updateHorse(CredentialsService.getCurrentTenantId(), horseId, data)
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  static async createHorse (data) {
    try {
      return await HorsesRepository.createHorse(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  static async createParentHorse (data) {
    try {
      return await HorsesRepository.createParentHorse(data)
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  static async getParentHorses (params) {
    try {
      return await HorsesRepository.getParentHorses(params)
    } catch (error) {
      console.log(error)
    }
  }

  

  static async getResultHorseExercise (horseId, exerciseId, params) {
    try {
      return await HorsesRepository.getResultHorseExercise(CredentialsService.getCurrentTenantId(), horseId, exerciseId, params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default HorseService
